import React from 'react';
import {connect} from 'react-redux';

// Components
import Input from 'Components/common/Input';
import Anchor from 'Components/common/Anchor';
import Select from 'Components/common/Select';
import Counter from 'Components/counter/Counter';
import BasicButton from 'Components/common/BasicButton';
import Dialog from 'Components/common/Dialog';
import {Checkbox, Grid} from '@material-ui/core';
import util from 'Utils/commonUtil';
// Actions
import {
    getSCList,
    applyBackup,
    getPersonalInfo,
    getAlphaList,
    getInventoryBySkuAndSC,
    updateMyOrderList,
} from 'Actions/userCenter';
import {getSysDict} from 'Actions/replenishment';
import {openNotification} from 'Actions/notification';
import {T} from 'Actions/translate';

// Icons
import {ArrowBackIos} from '@material-ui/icons';

class RequestBackup extends React.Component {
    state = {
        sku: '',
        quantity: 1,
        labOrDept: '',
        selectedValue: 0,
        scId: undefined,
        date: util.dateFilter(
            new Date().setDate(new Date().getDate() + 5),
            'yyyy-MM-dd',
        ),
        remark: '',
        alphaName: '',
        loginEmail: '',
        shipToNum: '',
        skuInventory: 100,
        backupOnroadQuantity: 0,
        skuModalComps: [
            {
                id: 1,
                sku: '',
                skuInventory: '',
                backupOnroadQuantity: '',
                applyQuantity: 1,
                reason: '',
                otherReason: '',
                stockUpQuantity: 0,
                yourQuantity: 0,
            },
        ],
        skuNum: 1,
        remarkNum: 0,
        updatingQuantityFlag: false,
        openBackupConfirmDialog: false,
        currentScName: '',
    };

    componentWillMount() {
        const {localData} = this.props;

        this.props.updateMyOrderList([]);
        this.props.getSCList().then((scList) => {
            if (localData.roleType === 0) {
                this.props.getPersonalInfo().then((personalInfo) => {
                    let labOrDept = undefined;
                    let scId = undefined;

                    personalInfo &&
                        personalInfo.data &&
                        personalInfo.data.shipTos &&
                        personalInfo.data.shipTos.forEach((item) => {
                            if (item.defaultShipTo) {
                                labOrDept = item.stAlphaName;
                            }
                        });

                    scList &&
                        scList.data &&
                        scList.data.forEach((item) => {
                            if (item.id === localData.scId) scId = item.id;
                        });

                    this.setState({
                        labOrDept,
                        scId,
                    });
                });
            }
        });

        let dictType = 'STOCK_UP_REASON';
        this.props.getSysDict(dictType);
    }

    gotoBackupList = () => this.props.history.push('/backupList');
    quantityChange = (value, currentIndex) => {
        this.setState(
            {
                updatingQuantityFlag: true,
            },
            () => {
                this.setState((prevState) => {
                    const updatedSkuModalComps = prevState.skuModalComps.map(
                        (skuModal) => {
                            if (currentIndex === skuModal.id) {
                                return {
                                    ...skuModal,
                                    applyQuantity: value,
                                };
                            }
                            return skuModal;
                        },
                    );

                    console.log(
                        'skuModalComps========================================1',
                        JSON.parse(JSON.stringify(updatedSkuModalComps)),
                    );
                    return {
                        skuModalComps: updatedSkuModalComps,
                        updatingQuantityFlag: false,
                    };
                });
            },
        );
    };

    inputChange = (title, value) => {
        if (
            title !== 'loginEmail' &&
            title !== 'alphaName' &&
            title !== 'shipTo'
        ) {
            this.setState({[title]: value});
        }
    };

    textChange = (title, value) => {
        if (value && value.length > 0) {
            let num = value && value.length;
            if (num >= 200) {
                num = 200;
            }

            this.setState({
                remarkNum: num,
                remark: value,
            });
        }
    };

    clearInput = () => {
        this.setState({
            remarkNum: 0,
        });
    };

    checkboxChange = (e) => {
        const value = Number(e.target.value);
        this.setState({
            selectedValue: value === 1 ? 0 : 1,
        });
    };

    handleSelectChange = (item) => {
        let skuDetails = [];
        let skuModalComps = JSON.parse(
            JSON.stringify(this.state.skuModalComps),
        );
        skuModalComps.forEach((skuModal, skuIndex) => {
            let currentSkuDetail = {
                id: skuModal.id,
                sku: '',
                skuInventory: '',
                backupOnroadQuantity: '',
                applyQuantity: 1,
                reason: '',
                otherReason: '',
                stockUpQuantity: 0,
                yourQuantity: 0,
            };
            skuDetails.push(currentSkuDetail);
        });
        console.log(
            'skuModalComps========================================1',
            JSON.parse(JSON.stringify(skuDetails)),
        );

        this.setState({
            scId: item.id,
            currentScName: item.name,
            skuModalComps: skuDetails,
        });
    };

    handleSelectBackupReasonChange = (item, comps) => {
        this.setState((prevState) => {
            const updatedSkuModalComps = prevState.skuModalComps.map(
                (skuModal) => {
                    if (comps.id === skuModal.id) {
                        return {
                            ...skuModal,
                            reason: item.key,
                        };
                    }
                    return skuModal;
                },
            );

            // console.log(
            //     'skuModalComps========================================1',
            //     JSON.parse(JSON.stringify(updatedSkuModalComps)),
            // );
            return {
                skuModalComps: updatedSkuModalComps,
            };
        });
    };

    inputSkuChange = (title, value) => {
        this.setState({[title]: value});
    };

    getCurrentBackupReasonFlag = () => {
        let isBackupReasoNotNull = true;
        let currentSkuModalComps = JSON.parse(
            JSON.stringify(this.state.skuModalComps),
        );
        currentSkuModalComps.forEach((skuModal, skuIndex) => {
            if (!skuModal.reason) {
                isBackupReasoNotNull = false;
            }
        });

        return isBackupReasoNotNull;
    };

    getCurrentBackupReasonFlag = () => {
        let isBackupReasoNotNull = true;
        let currentSkuModalComps = JSON.parse(
            JSON.stringify(this.state.skuModalComps),
        );
        currentSkuModalComps.forEach((skuModal, skuIndex) => {
            if (!skuModal.reason) {
                isBackupReasoNotNull = false;
            }
        });

        return isBackupReasoNotNull;
    };

    getCurrentOtherReasonFlag = () => {
        let isOtherReasoNotNull = true;
        let currentSkuModalComps = JSON.parse(
            JSON.stringify(this.state.skuModalComps),
        );
        currentSkuModalComps.forEach((skuModal, skuIndex) => {
            if (
                skuModal.reason &&
                skuModal.reason === 'other' &&
                !skuModal.otherReason
            ) {
                isOtherReasoNotNull = false;
            }
        });

        return isOtherReasoNotNull;
    };

    getCurrentOtherReasonLengthFlag = () => {
        let isOtherReasoLength = true;
        let currentSkuModalComps = JSON.parse(
            JSON.stringify(this.state.skuModalComps),
        );
        currentSkuModalComps.forEach((skuModal, skuIndex) => {
            if (
                skuModal.reason &&
                skuModal.otherReason &&
                skuModal.otherReason.length > 100
            ) {
                isOtherReasoLength = false;
            }
        });

        return isOtherReasoLength;
    };

    submitHandle = () => {
        const {scId} = this.state;
        let skuDetails = [];
        let skuModalComps = JSON.parse(
            JSON.stringify(this.state.skuModalComps),
        );
        skuModalComps.forEach((skuModal, skuIndex) => {
            let currentSkuDetail = {
                sku: skuModal.sku,
                applyQuantity: skuModal.applyQuantity,
                reason: skuModal.reason,
                otherReason: skuModal.reason ? skuModal.otherReason : '',
            };
            skuDetails.push(currentSkuDetail);
        });

        let isNotNull = true;
        let currentSkuModalComps = JSON.parse(
            JSON.stringify(this.state.skuModalComps),
        );
        currentSkuModalComps.forEach((skuModal, skuIndex) => {
            if (!skuModal.sku) {
                isNotNull = false;
            }
        });

        if (!scId) {
            return this.props.openNotification(
                T('backup_please_select_supply_center'),
                'danger',
            );
        } else if (!isNotNull) {
            return this.props.openNotification(
                T('pleaseEnter') + T('sku'),
                'danger',
            );
        } else if (!this.getCurrentBackupReasonFlag()) {
            return this.props.openNotification(
                T('backup_application_reason_placeholder'),
                'danger',
            );
        } else if (!this.getCurrentOtherReasonFlag()) {
            return this.props.openNotification(
                T('backup_application_other_reason_not_null'),
                'danger',
            );
        } else if (!this.getCurrentOtherReasonLengthFlag()) {
            return this.props.openNotification(
                T('backup_application_other_reason_not_more_than_100'),
                'danger',
            );
        } else {
            this.setState({
                openBackupConfirmDialog: true,
            });
        }
    };

    submit = () => {
        const {scId} = this.state;
        let skuDetails = [];
        let skuModalComps = JSON.parse(
            JSON.stringify(this.state.skuModalComps),
        );

        skuModalComps.forEach((skuModal, skuIndex) => {
            let currentSkuDetail = {
                sku: skuModal.sku,
                applyQuantity: skuModal.applyQuantity,
                reason: skuModal.reason,
                remark: skuModal.otherReason,
            };
            skuDetails.push(currentSkuDetail);
        });

        const data = {
            supplyCenterId: scId,
            skuDetails: skuDetails,
        };

        this.props
            .applyBackup(data)
            .then(() => {
                this.props.openNotification(
                    T('notification_we_have_received_your_application'),
                );
                this.props.history.push('/backupList');
            })
            .catch((res) => {
                let currentSkuModalComps = JSON.parse(
                    JSON.stringify(this.state.skuModalComps),
                );

                if (res.status === 'Invalid_Sku') {
                    currentSkuModalComps.forEach(
                        (backupSkuModal, madalIndex) => {
                            backupSkuModal.sku = '';
                        },
                    );
                    this.props.openNotification(T('notification_invalid_sku'));
                    this.setState({
                        skuModalComps: currentSkuModalComps,
                    });
                }
            });
    };

    inputSkuQueryChange = (title, value) => {
        let number = parseInt(title.slice(3));
        let currentSkuModalComps = JSON.parse(
            JSON.stringify(this.state.skuModalComps),
        );
        currentSkuModalComps.forEach((skuModal, skuIndex) => {
            if (number === skuModal.id) {
                skuModal.sku = value;
            }
        });

        // console.log(
        //     'skuModalComps========================================3',
        //     JSON.parse(JSON.stringify(currentSkuModalComps)),
        // );
        this.setState({
            [title]: value,
            skuModalComps: currentSkuModalComps,
        });
    };

    inputOtherReasonChange = (title, value) => {
        // let number = parseInt(title.slice(3));
        let number = parseInt(title.split('-')[1]);
        let currentSkuModalComps = JSON.parse(
            JSON.stringify(this.state.skuModalComps),
        );
        currentSkuModalComps.forEach((skuModal, skuIndex) => {
            if (number === skuModal.id) {
                skuModal.otherReason = value;
            }
        });

        console.log(
            'skuModalComps========================================3',
            JSON.parse(JSON.stringify(currentSkuModalComps)),
        );
        this.setState({
            [title]: value,
            skuModalComps: currentSkuModalComps,
        });
    };

    blurSkuQueryChange = (currentSkuIndex) => {
        let currentSkuModalComps = JSON.parse(
            JSON.stringify(this.state.skuModalComps),
        );
        let currentSku = 0;
        currentSkuModalComps.forEach((skuModal, skuIndex) => {
            if (currentSkuIndex === skuModal.id) {
                currentSku = skuModal.sku;
            }
        });
        const {scId} = this.state;
        if (typeof scId === 'undefined') {
            this.props.openNotification(
                T('backup_please_select_supply_center'),
            );
        } else {
            if (currentSku.trim()) {
                let params = {
                    supplyCenterId: scId,
                    sku: currentSku.trim(),
                };
                this.props
                    .getInventoryBySkuAndSC(params)
                    .then((res) => {
                        if (res.status === 'success') {
                            if (res.data) {
                                this.setState((prevState) => {
                                    const updatedSkuModalComps = prevState.skuModalComps.map(
                                        (skuModal) => {
                                            if (
                                                currentSkuIndex === skuModal.id
                                            ) {
                                                if (res.data.sku) {
                                                    skuModal.sku = res.data.sku;
                                                }
                                                skuModal.skuInventory =
                                                    res.data.displayInventory;
                                                skuModal.backupOnroadQuantity =
                                                    res.data.onLoadQuantity;

                                                skuModal.stockUpQuantity = res
                                                    .data.stockUpQuantity
                                                    ? res.data.stockUpQuantity
                                                    : 0;
                                                skuModal.yourQuantity =
                                                    res.data.yourQuantity;
                                            }
                                            return skuModal;
                                        },
                                    );

                                    console.log(
                                        'skuModalComps========================================4',
                                        JSON.parse(
                                            JSON.stringify(
                                                updatedSkuModalComps,
                                            ),
                                        ),
                                    );

                                    return {
                                        skuModalComps: updatedSkuModalComps,
                                    };
                                });
                            } else {
                                currentSkuModalComps.forEach(
                                    (backupSkuModal, madalIndex) => {
                                        if (
                                            currentSkuIndex ===
                                            backupSkuModal.id
                                        ) {
                                            backupSkuModal.skuInventory = '';
                                            backupSkuModal.backupOnroadQuantity =
                                                '';
                                        }
                                    },
                                );
                                console.log(
                                    'skuModalComps========================================5',
                                    JSON.parse(
                                        JSON.stringify(currentSkuModalComps),
                                    ),
                                );
                                this.setState({
                                    skuModalComps: currentSkuModalComps,
                                });
                            }
                        }
                    })
                    .catch((res) => {
                        currentSkuModalComps.forEach(
                            (backupSkuModal, madalIndex) => {
                                if (currentSkuIndex === backupSkuModal.id) {
                                    backupSkuModal.skuInventory = '';
                                    backupSkuModal.backupOnroadQuantity = '';
                                }
                            },
                        );
                        if (res.status === 'black_sku') {
                            currentSkuModalComps.forEach(
                                (backupSkuModal, madalIndex) => {
                                    if (currentSkuIndex === backupSkuModal.id) {
                                        backupSkuModal.sku = '';
                                    }
                                },
                            );
                            this.props.openNotification(
                                currentSku.trim() +
                                    T('backup_not_application') +
                                    T('backup_due_to') +
                                    res.message,
                            );
                        } else if (res.status === 'invalid_sku') {
                            currentSkuModalComps.forEach(
                                (backupSkuModal, madalIndex) => {
                                    if (currentSkuIndex === backupSkuModal.id) {
                                        backupSkuModal.sku = '';
                                    }
                                },
                            );
                        }
                        console.log(
                            'skuModalComps========================================6',
                            JSON.parse(JSON.stringify(currentSkuModalComps)),
                        );
                        this.setState({
                            skuModalComps: currentSkuModalComps,
                        });
                    });
            }
        }
    };

    addBackupSkuModal = () => {
        let {skuModalComps, skuNum} = this.state;
        skuModalComps.push({
            id: skuNum + 1,
            sku: '',
            skuInventory: '',
            backupOnroadQuantity: '',
            applyQuantity: 1,
            stockUpQuantity: 0,
            yourQuantity: 0,
        });
        console.log(
            'skuModalComps========================================7',
            JSON.parse(JSON.stringify(skuModalComps)),
        );
        this.setState({
            skuModalComps: skuModalComps,
            skuNum: ++skuNum,
        });
    };

    deletBackupSkuModal = (comps) => {
        let {skuModalComps} = this.state;
        if (skuModalComps.length > 1) {
            // skuModalComps.splice(comps-1,1);

            skuModalComps.splice(
                skuModalComps.findIndex((item) => item.id === comps),
                1,
            );
            console.log(
                'skuModalComps========================================8',
                JSON.parse(JSON.stringify(skuModalComps)),
            );
            this.setState({
                skuModalComps: skuModalComps,
            });
        } else {
            this.props.openNotification(T('backup_need_one_sku'));
        }
    };

    goToSelectCustomerInfor = () => {
        this.props.history.push('/selectCustomer/', {
            roleType: this.props.localData.roleType,
            moduleFlag: 'backup',
        });
    };

    closeDialog = (name) => {
        if (this.state[name]) {
            this.setState({
                [name]: false,
            });
        }
    };

    render() {
        const {
            scId,
            selectedValue,
            skuModalComps,
            updatingQuantityFlag,
            openBackupConfirmDialog,
            currentScName,
        } = this.state;

        return (
            <div className="request-backup-container">
                <div>
                    <div className="request-backup-header container-max-width is-fixed">
                        <Anchor
                            className="back-btn"
                            onClickOfSingleTap={this.gotoBackupList}>
                            <ArrowBackIos className="back-icon" />
                        </Anchor>
                        {T('apply_backup_title')}
                    </div>

                    <div className="notice-banner container-max-width is-fixed">
                        <div className="notice-banner-text">
                            {T('backup_apply_banner_info')}
                        </div>
                    </div>
                </div>
                <section className="request-content backup-basic-infor">
                    <div className="row">
                        <label className="required-label">*</label>
                        <label>{T('backup_supply_center')}</label>
                        <Select
                            className="select"
                            value={scId}
                            placeholder={T(
                                'backup_please_select_supply_center',
                            )}
                            data={this.props.SCList}
                            displayKey="name"
                            valueKey="id"
                            onChange={this.handleSelectChange}
                            options={{icon: {show: true, color: '#E82D38'}}}
                        />
                    </div>
                </section>
                {skuModalComps.map((comps, index) => (
                    <section
                        key={index + 1}
                        className={'request-content sku-modal-' + comps.id}>
                        <div className="row">
                            <label className="required-label">*</label>
                            <label>{T('sku')}</label>
                            <Input
                                type="text"
                                disabled={scId ? false : true}
                                title={'sku' + comps.id}
                                value={comps.sku}
                                key={comps.id}
                                onChange={this.inputSkuQueryChange}
                                onBlur={() => this.blurSkuQueryChange(comps.id)}
                                placeholder={T('backup_please_input_sku')}
                            />
                            <Anchor
                                className="delete-backup-a"
                                onClickOfSingleTap={() =>
                                    this.deletBackupSkuModal(comps.id)
                                }>
                                <span className="backup-delete-btn">
                                    {T('backup_delete_button')}
                                </span>
                            </Anchor>
                        </div>
                        <div className="row  not-require-row">
                            <div className="backup-inventory-div">
                                <label>{T('backup_inventory_quantity')}</label>
                                <div className="read-area">
                                    {comps.skuInventory}
                                </div>
                            </div>
                            <div className="onroad-quantity-area">
                                <label>{T('backup_onroad_quantity')}</label>
                                <div className="read-area">
                                    {comps.backupOnroadQuantity}
                                </div>
                            </div>
                        </div>
                        <div className="row backup_last-row  not-require-row">
                            <label>{T('backup_application_quantity')}</label>
                            <Counter
                                defalutValue={comps.applyQuantity}
                                currentSkuIndex={comps.id}
                                inputValid={this.quantityChange}
                                options={{min: 1}}
                            />
                        </div>
                        <div className="row">
                            <label className="required-label">*</label>
                            <label>{T('backup_application_reason')}</label>
                            <Select
                                className="select"
                                value={comps.reason}
                                placeholder={T(
                                    'backup_application_reason_placeholder',
                                )}
                                data={this.props.backupReasonList}
                                displayKey="value"
                                valueKey="key"
                                currentFunction="backup"
                                onChange={(item) =>
                                    this.handleSelectBackupReasonChange(
                                        item,
                                        comps,
                                    )
                                }
                                options={{icon: {show: true, color: '#E82D38'}}}
                            />
                        </div>

                        <div className="row backup_last-row">
                            <div>
                                {comps.reason === 'other' ? (
                                    <label className="required-label">*</label>
                                ) : null}
                                <label className="other-reason-label">
                                    {T('backup_application_other_reason')}
                                </label>
                            </div>
                            <Input
                                type="text"
                                title={'otherReason-' + comps.id}
                                value={comps.otherReason}
                                key={comps.id}
                                onChange={this.inputOtherReasonChange}
                                placeholder={T(
                                    'backup_please_input_other_reason',
                                )}
                            />
                        </div>

                        {comps.stockUpQuantity !== 0 ? (
                            <div className="current-backup-content">
                                <label>
                                    {T('backup_stockup_quantity', [
                                        comps.stockUpQuantity,
                                    ])}
                                </label>
                            </div>
                        ) : null}
                    </section>
                ))}
                <div className="add-apply-sku-div">
                    <BasicButton
                        className="add-sku-area"
                        onClickOfSingleTap={this.addBackupSkuModal}>
                        <label className="plus-label">+</label>
                        {T('backup_add_sku_button')}
                    </BasicButton>
                </div>
                <div className="add-apply-checkbox">
                    <Checkbox
                        checked={selectedValue === 1}
                        onChange={this.checkboxChange}
                        value={selectedValue}
                        className={
                            selectedValue
                                ? 'radio-button checked'
                                : 'radio-button'
                        }
                    />{' '}
                    <p className="add-apply-checkbox-describe">
                        {T('backup_host_sales_apply_goods')}
                    </p>
                </div>
                <BasicButton
                    disabled={
                        selectedValue === 1 && !updatingQuantityFlag
                            ? false
                            : true
                    }
                    className="submit-btn"
                    type="primary"
                    onClickOfSingleTap={this.submitHandle}>
                    {T('apply_backup_submit')}
                </BasicButton>

                <Dialog
                    dialogDidClose={() =>
                        this.closeDialog('openBackupConfirmDialog')
                    }
                    opened={openBackupConfirmDialog}
                    options={{bgClickClose: true}}>
                    <div className="backup-dialog">
                        <Grid className="dialog-title" container spacing={0}>
                            <Grid item xs={12}>
                                <span>{T('backup_confirm_stock_up')}</span>
                            </Grid>
                        </Grid>

                        <Grid
                            className="dialog-content"
                            container
                            spacing={0}
                            justify={'left'}>
                            <Grid item xs={12}>
                                <span>{currentScName}</span>
                            </Grid>

                            {skuModalComps.map((comps, index) => (
                                <Grid item xs={12} className="sku-container">
                                    <Grid className="backup-sku-content">
                                        <label>{T('backup_sku')}:</label>
                                        {comps.sku}
                                    </Grid>
                                    <Grid className="backup-sku-content">
                                        <label>{T('backup_quantity')}:</label>
                                        {comps.applyQuantity}
                                    </Grid>
                                </Grid>
                            ))}
                        </Grid>

                        <Grid container spacing={0}>
                            <Grid item xs={12} align="center">
                                <BasicButton
                                    className="cancel-confirm-btn"
                                    type="primary"
                                    disabled={false}
                                    onClickOfSingleTap={() => {
                                        this.closeDialog(
                                            'openBackupConfirmDialog',
                                        );
                                    }}>
                                    <span>{T('backup_confirm_cancel')}</span>
                                </BasicButton>
                                <BasicButton
                                    className="confirm-btn"
                                    type="primary"
                                    disabled={false}
                                    onClickOfSingleTap={this.submit}>
                                    <span>{T('backup_confirm_submit')}</span>
                                </BasicButton>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {localData, userCenter} = state;

    return {
        localData,
        SCList: userCenter.SCList,
        alphaList: userCenter.alphaList,
        inventoryInfor: userCenter.inventoryInfor,
        backupReasonList: userCenter.backupReasonList,
    };
};

const mapDispatchToProps = {
    getSCList,
    applyBackup,
    openNotification,
    getPersonalInfo,
    getAlphaList,
    getInventoryBySkuAndSC,
    getSysDict,
    updateMyOrderList,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestBackup);
